var crTracker = (function() {
	var _currentClickedElement = null;
	var _regExpExternal = /^http(s)?:\/\//;
	var _regExpCrLinks = /^(http(s)?:\/\/)?(www|beta-m|beta|staging|dev-m|dev(\d)?|(v2)?[a-z]{1,4}.local)?(\.)?cityrealty\.com/i;
	var _regExpAdServer = /\/ad-server\//;
	var _regExpExceptions = /(www.solowresidential.com)|(www.bettinaequities.com)|(www.nightingale.org)|(www.bankofamerica.com)|(www.mns.com)/;
	var envUrl;
	switch (E) {
	case 1: { // prod
		envUrl = '//metis.cityrealty.com';
		break;
	}
	case 2: { // beta
		//yes, this is a server alias as workaround
		envUrl = '//beta-metis.cityrealty.com';
		break;
	}
	case 3: { // staging
		envUrl = '//dev74-metis.cityrealty.com';
		break;
	}
	case 4: { // dev
		envUrl = '//dev74-metis.cityrealty.com';
		break;
	}
	case 5: { // local
		envUrl = '//dev74-metis.cityrealty.com';
		break;
	}
	case 6: { // local
		envUrl = '//dev74-metis.cityrealty.com';
		break;
	}
	default: {
		envUrl = '//dev74-metis.cityrealty.com';
		break;
	}
	}
	var _urlTracking = envUrl + '/v1/link/exit';
	var _paramName = '_ct';

	/**
	 * This function retrieves and complete the data to be sent to the back end
	 * The data are retrived from the _metis global object
	 * And we add the date and the redirection url
	 * @param  {String} url The url parameter
	 * @param  {String} adId The the id of the AD if link it was for ad server
	 * @return {Object}     The data ready for the xhr call
	 */
	var getTrackingData = function(url, adId, widgetId) {
		var data = {};
		for (var property in _metis) {
			if (_metis.hasOwnProperty(property)) {
				data[property] = _metis[property];
			}
		}
		data.a = adId;
		data.d = moment().utc().format('YYYY-MM-DD HH:mm:ss');
		data.ue = url;

		// if we have a widget id the overwrite listing id or building id
		if (widgetId) {
			var widgetInfos = widgetId.split(';');
			var main = widgetInfos[0].split('-');
			var extra = widgetInfos[1];

			var type = main[0];
			var id = main[1];
			if (type === 'listing') {
				data.l = id;
			} else if (type === 'building') {
				data.b = id;
			} else if (type === 'article') {
				data.ma = id;
			}

			if (extra) {
				extra = extra.split('-');
				var extraType = extra[0];
				var extraId = extra[1];

				if (extraType === 'building') {
					data.b = extraId;
				}
			}
		}

		return data;
	};

	/**
	 * Send an xhr request with tracking infos
	 * @param  {String} url The url param to send with the data
	 * @param  {String} adId The the id of the AD if link it was for ad server
	 */
	var sendXhr = function(url, adId, widgetId) {
		var xhttp = new XMLHttpRequest();
		xhttp.open("POST", _urlTracking, true);
		xhttp.setRequestHeader("Content-type", "application/json");
		xhttp.withCredentials = true;
		var data = getTrackingData(url, adId, widgetId);
		xhttp.send(JSON.stringify(data));
		xhttp.onreadystatechange = function() {
			if (this.readyState === 4 && this.status === 200) {
				// success
			}
		};
	};

	/**
	 * This function translate a param object into a string with get parameters
	 * The param object can contain single value and array
	 * @param  {Object} paramsObject Object to be translated
	 * @return {String} The string containing the get parameters
	 */
	var paramsToUrl = function(paramsObject) {
		var paramsRpc = "";
		var firstItem = true;
		// add the list of params
		for(var key in paramsObject) {
			if (paramsObject.hasOwnProperty(key)) {
				// param is a single value
				if (!firstItem) {
					paramsRpc += "&";
				}
				paramsRpc += key + "=" + paramsObject[key];
				firstItem = false;
			}
		}
		return paramsRpc;
	};

	/**
	 * This function get the parameters from a given url and return an object
	 * @param  {String} url Url to parse
	 * @return {Object}     Object with all the params
	 */
	var getParamsFromUrl = function(url) {
		var regex = /[?&]([^=#]+)=([^&#]*)/g;
		var params = {};
		var match;

		while (match = regex.exec(url)) {
			params[match[1]] = match[2];
		}
		return params;
	};

	/**
	 * Append token parameter to the url
	 * @param  {String} url The base url
	 * @return {String} New url with token
	 */
	var addTokenToUrl = function(url, adserver) {
		var paramMetis = _paramName + '=' + _metis.t;
		var params = getParamsFromUrl(url);
		var absoluteUrl = url.match(/^[^#\?]+/)[0];

		// Check if there are already params or not
		if (params && Object.keys(params).length > 0) {
			// if it is a adserver link, we have to append the token to the end of the url param
			if (adserver) {
				if (params.url) {
					var decodedUrl = decodeURIComponent(params.url);
					// If the param is not already there, then add it
					if (decodedUrl.indexOf(_paramName) === -1) {
						var paramsUrl = getParamsFromUrl(decodedUrl);
						// if there are already params we append the new one with &
						// if not we append it with ?
						if (paramsUrl && Object.keys(paramsUrl).length > 0) {
							decodedUrl += '&' + paramMetis;
						} else {
							decodedUrl += '?' + paramMetis;
						}
						params.url = encodeURIComponent(decodedUrl);
						url = absoluteUrl + '?' + paramsToUrl(params);
					}
				}
			// if it is any other kind of url we append the token at the end
			// if the param is not already there, then add it
			} else if (Object.keys(params).indexOf(_paramName) === -1) {
				url += '&' + paramMetis;
			}
		} else {
			url += '?' + paramMetis;
		}

		return url;
	};

	/**
	 * Retrieve the closest ancestor from a given node name
	 * @param  {HTMLElement} element     Element from where we start looking at the ancestor
	 * @param  {String} ancestorNodeName Name of the node
	 * @return {HTMLElement}             The ancestor element found or null
	 */
	var findAncestor = function(element, ancestorNodeName) {
		while ((element = element.parentElement) && element.nodeName !== ancestorNodeName);
		return element;
	};

	/**
	 * Retrieve the closest ancestor from a given node name
	 * @param  {HTMLElement} element     Element from where we start looking at the ancestor
	 * @param  {String} ancestorNodeName Name of the node
	 * @return {HTMLElement}             The ancestor element found or null
	 */
	var findWidget = function(element) {
		while ((element = element.parentElement) && !element.getAttribute('data-component-info'));
		return element;
	};

	/**
	 * [function description]
	 * @param  {[type]} event [description]
	 * @return {[type]}       [description]
	 */
	var callbackTrackEvent = function(event) {
		var target = event.target || event.srcElement;

		// Retrieve the link if a link has been clicked
		// Or a direct child of the link (such as img tag)
		var link;
		if (target.nodeName === 'A') {
			link = target;
		} else {
			link = findAncestor(target, 'A');
		}


		if (link) {
			var href = link.getAttribute('href');
			if (href) {
				// trim white spaces
				href = href.trim();
				// Check if the link is external or not
				var res = _regExpExternal.test(href);
				if (res) {
					// Check if the link is a Cr link
					var resCr = _regExpCrLinks.test(href);
					var adserver = _regExpAdServer.test(href);

					if (!resCr || (resCr && adserver)) {
						// Check if the url is an exceptionnal one
						var resExcep = _regExpExceptions.test(href);
						if (!resExcep) {
							// Change the href to append the token at the end
							href = addTokenToUrl(href, adserver);
							link.setAttribute('href', href);
						}

						var widget = findWidget(target);
						var widgetId = widget ? widget.getAttribute('data-component-info') : null;
						var adId = link.hasAttribute('data-track-id') ? link.getAttribute('data-track-id') : '';
						sendXhr(href, adId, widgetId);
					}
				}
			}
		}
	};

	return {
		/**
		 * This function is responsible to send tracking xhr request on click
		 * We check if the element is a link
		 * Or if a direct child of a link has been clicked
		 */
		trackClickEvent: function() {
			var onTouchEvent = false;
			var onTouchMove = false;

			// track click
			document.addEventListener('click', function(event) {
				if (!onTouchEvent) {
					callbackTrackEvent(event);
				}
				onTouchEvent = false;
			});

			// For Mobile
			document.addEventListener('touchend', function(event) {
				if (!onTouchMove) {
					onTouchEvent = true;
					callbackTrackEvent(event);
				}
			});

			document.addEventListener('touchmove', function(event) {
				onTouchMove = true;
			});

			document.addEventListener('touchstart', function(event) {
				onTouchMove = false;
			});
		}
	};
})();
